export default function Footer() {
  return (
    <>
      <footer className="footer bg-dark p-3 text-white">
        <div className="container">
          <p className="text-muted text-center">© 2025 Konica Minolta, Inc.</p>
        </div>
      </footer>
    </>
  );
}
